import { ExportCurve, SearchNormal } from "iconsax-reactjs";
import { Button, Input, Select } from "../../../shared/ui";

type Option = {
  value: string;
  label: string;
};

type KybComplianceFiltersBarProps = {
  query: string;
  onQueryChange: (value: string) => void;
  sort: string;
  onSortChange: (value: string) => void;
  sortOptions: Option[];
  businessType: string;
  onBusinessTypeChange: (value: string) => void;
  businessTypeOptions: Option[];
  country: string;
  onCountryChange: (value: string) => void;
  countryOptions: Option[];
  isExporting?: boolean;
  onExport: () => void;
};

const KybComplianceFiltersBar = ({
  query,
  onQueryChange,
  sort,
  onSortChange,
  sortOptions,
  businessType,
  onBusinessTypeChange,
  businessTypeOptions,
  country,
  onCountryChange,
  countryOptions,
  isExporting = false,
  onExport,
}: KybComplianceFiltersBarProps) => {
  return (
    <div className="my-4 flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
      <Button
        type="button"
        onClick={onExport}
        disabled={isExporting}
        className="order-1 self-start px-7 text-[14px] font-[550] lg:order-2 lg:px-5"
      >
        <ExportCurve size={18} />
        {isExporting ? "Exporting..." : "Export"}
      </Button>

      <div className="order-2 flex flex-1 flex-col gap-4 lg:order-1 lg:flex-row lg:items-center lg:gap-3">
        <Input
          value={query}
          onChange={(event) => onQueryChange(event.target.value)}
          placeholder="Search by customer, business name, etc.."
          startIcon={<SearchNormal size={20} className="text-[#6F739B]" />}
          className="w-full lg:w-[360px]"
        />

        <div className="hidden h-10 w-px bg-[#EEF1FB] lg:block" />

        <div className="flex w-full flex-col gap-3 lg:w-auto lg:flex-row lg:flex-wrap lg:items-center">
          <Select
            value={sort}
            onChange={onSortChange}
            title="Sort by"
            placeholder="Newest first"
            triggerPrefix="Sort"
            className="w-full lg:w-auto"
            options={sortOptions}
          />
          <Select
            value={businessType}
            onChange={onBusinessTypeChange}
            title="Business type"
            placeholder="All"
            triggerPrefix="Business type"
            className="w-full lg:w-auto"
            options={businessTypeOptions}
          />
          <Select
            value={country}
            onChange={onCountryChange}
            title="Country"
            placeholder="All"
            triggerPrefix="Country"
            className="w-full lg:w-auto"
            options={countryOptions}
          />
        </div>
      </div>
    </div>
  );
};

export default KybComplianceFiltersBar;
